import axios from 'axios';
import { auth } from './auth';

const baseURL = process.env.REACT_APP_API_URL;

if (!baseURL) {
  throw new Error(
    'Missing REACT_APP_API_URL. Define it before starting the frontend.'
  );
}

const api = axios.create({
  baseURL,
  withCredentials: true,
  headers: { 'ngrok-skip-browser-warning': '69420' }
});

// Always read the latest token before each request (not only at boot)
api.interceptors.request.use((config) => {
  const token = auth.getToken();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Auto-logout on 401 (except on auth routes)
api.interceptors.response.use(
  (res) => res,
  (error) => {
    const status = error?.response?.status;
    const url = error?.config?.url || '';

    if (status === 401 && !auth.isAuthUrl(url)) {
      auth.logout();
    }
    return Promise.reject(error);
  }
);

export default api;
